import React from 'react';
import { graphql } from 'gatsby';
import Divider from '@solid-ui-components/Divider';
import {
  normalizeBlockContentNodes,
  useHighlightAnchors,
} from '@blocks-helpers';
import BasePage from '@elegantstack/solid-ui-blocks/src/BasePage';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper';
import { Flex } from 'theme-ui';
import KnowledgeBaseArticleInfoBlock from '@solid-ui-blocks/KnowledgeBaseArticleInfoBlock';
import KnowledgeBaseArticleNav from '@solid-ui-blocks/KnowledgeBaseArticleNav';
import styles from './_styles';
import KnowledgeBaseArticleAside from '@solid-ui-blocks/KnowledgeBaseArticleAside';
import KnowledgeBaseArticleMobileNav from '@solid-ui-blocks/KnowledgeBaseArticleMobileNav';
import { Helmet } from 'react-helmet';

const KnowledgeBaseOrganizationCreation = (props) => {
  const {
    data: { allBlockContent },
    location: { pathname },
  } = props;
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);

  const anchors = [
    'creating-organization',
    'deleting-an-organization-and-transferring-ownership',
    'tips-for-managing-organizations',
  ];

  useHighlightAnchors(anchors);

  return (
    <>
    <Helmet>
      <link rel="canonical" href={`https://targpatrol.com/knowledge-base-organization-creation/`} />
    </Helmet>
    <BasePage
      description={
        'Learn how to set up and manage an organization in the employee task management platform TARGPatrol: how to create, edit, delete, or transfer ownership.'
      }
      title={'Organization Management in TARGPatrol'}
      keywords={'task management, task tracker, free task management software, task tracking tools, best task tracking app, task and project management software, project management software task'.split(
        ', '
      )}
      pathname={pathname}
      {...props}
    >
      <LayoutWrapper divider={<Divider />}>
        <>
          <KnowledgeBaseArticleNav content={content['nav']} />
          <KnowledgeBaseArticleMobileNav content={content['mobile-nav']} />
          <Flex sx={styles.articleContainer}>
            <Flex as='main' sx={styles.articleMain}>
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-1']}
              />
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-2']}
              />
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-3']}
              />
              <KnowledgeBaseArticleInfoBlock
                content={content['info-block-4']}
              />
            </Flex>
            <KnowledgeBaseArticleAside content={content['aside']} />
          </Flex>
        </>
      </LayoutWrapper>
    </BasePage>
    </>
  );
};

export const query = graphql`
  query knowledgeBaseOrganizationCreationTargpatrolEnBlockContent {
    allBlockContent(
      filter: {
        page: {
          in: ["targpatrol-en/knowledge-base-organization-creation", "shared"]
        }
      }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`;
export default KnowledgeBaseOrganizationCreation;
